<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="close(false)" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<ng-container>
		<h3 cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="flex flex-row- justify-start items-center cursor-move" mat-dialog-title>
			{{ t('billing.editCostGroupType') }}
		</h3>
		<div class="flex flex-col">
			<mat-dialog-content>
				<div [formGroup]="costGroupFg" class="flex flex-col pt-4">
					<div class="flex flex-row">
						<mat-form-field appearance="outline" class="mx-2 w-[50%]">
							<mat-label>{{ t('billing.name') }}</mat-label>
							<input formControlName="name" matInput />
						</mat-form-field>
						<mat-form-field appearance="outline" class="mx-2 w-[50%]">
							<mat-label>{{ t('common.printName') }}</mat-label>
							<input formControlName="printName" matInput />
						</mat-form-field>
					</div>
					<div class="flex flex-row">
						<mat-form-field appearance="outline" class="mx-2 w-full">
							<mat-label>{{ t('billing.description') }}</mat-label>
							<input formControlName="description" matInput />
						</mat-form-field>
					</div>
				</div>
			</mat-dialog-content>
		</div>
	</ng-container>
	<ng-container>
		<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
			<button (click)="close(true)" color="primary" mat-raised-button type="submit">
				<mat-icon>check</mat-icon>
				@if (!layoutService.isMobile()) {
					<span>
						{{ t('common.apply') }}
					</span>
				}
			</button>
		</mat-dialog-actions>
	</ng-container>
</div>
